module.exports = __webpack_public_path__ + "img/183.fa5f6645.jpg";